import './caseStudy.scss';

import { Link } from '@ets-global/b2c-website-ui';
import classNames from 'classnames';
import React from 'react';
import { Trans } from 'react-i18next';

import { paths } from '../../../paths';
import Subtitle from '../../Base/Title/Subtitle';
import ImgLazyLoad from '../../ImgLazyLoad';

const CaseStudyBlock = ({ slug, title, image, className }) => (
  <div className={classNames('case-study', className)}>
    {image && <ImgLazyLoad className="case-study__image" url={image.url} />}

    <div className="case-study__content">
      <Subtitle className="case-study__type" modifier={'blue'}>
        <Trans>blog.editorial-content.category.case_study</Trans>
      </Subtitle>
      <p className="case-study__title">
        <Link to={paths.BLOG_ARTICLE} params={{ editorialContentType: 'case-study', slug }} aria-label={title}>
          {title}
        </Link>
      </p>
    </div>
  </div>
);

export default CaseStudyBlock;
